module.exports = __webpack_public_path__ + "media/src/images/icons/flags/argentina-8decbf2b79d244f8d866325021d04015.svg";